import { useState } from 'react';
import { CheckCircle } from 'lucide-react';

const API = import.meta.env.VITE_API_URL;

interface Props { navigate: (path: string) => void }

export default function ForgotPassword({ navigate }: Props) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    await fetch(`${API}/affiliate-portal/forgot-password`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    });
    setLoading(false);
    setSent(true);
  };

  return (
    <div className="min-h-screen bg-white dark:bg-slate-950 font-inter flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-lg shadow-sm p-6">
        <h1 className="text-xl font-bold text-slate-900 dark:text-white mb-2">Reset Password</h1>

        {sent ? (
          <div className="text-center py-6">
            <CheckCircle className="w-12 h-12 text-green-600 dark:text-green-400 mx-auto mb-3" />
            <p className="text-slate-700 dark:text-slate-300">
              If <strong>{email}</strong> is registered as an affiliate, a password reset link has been sent. Check your inbox (and spam folder).
            </p>
            <button onClick={() => navigate('/login')} className="mt-4 px-4 py-2 bg-cyan-600 hover:bg-cyan-700 text-white rounded">
              Back to sign in
            </button>
          </div>
        ) : (
          <>
            <p className="text-sm text-slate-600 dark:text-slate-400 mb-4">
              Enter your email and we'll send you a link to reset your password. If you're an affiliate but have never set a password, this will also send you a setup link.
            </p>
            <form onSubmit={submit} className="space-y-4">
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="you@example.com" className="w-full border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 rounded px-3 py-2" />
              <button type="submit" disabled={loading} className="w-full bg-cyan-600 hover:bg-cyan-700 text-white py-2 rounded font-medium disabled:opacity-50">
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
            <div className="mt-3 text-center text-sm">
              <button onClick={() => navigate('/login')} className="text-cyan-600 dark:text-cyan-400 hover:underline">Back to sign in</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
